type Props = {
    severity: number;
    severityText: string;
    isFuture?: boolean;
};

export const SeverityBadge = ({ severity, severityText, isFuture }: Props) => {
    return <span className={`badge severity-badge-${isFuture ? 'gray' : severity}`}>{severityText}</span>;
};
